import { Module } from "vuex";
import { RootState, ShoppingListState } from "@/types/shoppingList";
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

const state: ShoppingListState = {
  foodList: null,
  recommendList: null,
  consumedList: null,
  rankingList: null,
  favoriteList: null,
  sceneCategoryList: null,
  chackedList: null,
  registingFoodList: null,
  searchResltList: null,
  registResultList: null,
  previousSelectCategoryIndex: 0,
  pantryList: null
};

export const shoppingList: Module<ShoppingListState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
